
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail, MapPin } from "lucide-react";

interface ContactInfoProps {
  email: string;
  address: string;
}

export const ContactInfoCard = ({ email, address }: ContactInfoProps) => {
  return (
    <Card className="md:col-span-1">
      <CardHeader>
        <CardTitle>Contact Information</CardTitle>
        <CardDescription>
          Reach out to us through any of these channels
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-start">
          <Mail className="h-5 w-5 text-primary mr-3 mt-0.5" />
          <div>
            <p className="font-medium">Email</p>
            <a href={`mailto:${email}`} className="text-muted-foreground hover:text-primary">
              {email}
            </a>
          </div>
        </div>
        
        <div className="flex items-start">
          <MapPin className="h-5 w-5 text-primary mr-3 mt-0.5" />
          <div>
            <p className="font-medium">Address</p>
            <p className="text-muted-foreground">{address}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
